import api from './client';
import type { AxiosResponse } from 'axios';

export const getEliteFeatures = (): Promise<AxiosResponse> => api.get('/elite/features');
export const createEliteCheckout = (planId: string): Promise<AxiosResponse> => api.post('/payments/checkout', { plan: `elite_${planId}` });
export const getEliteEvents = (): Promise<AxiosResponse> => api.get('/elite/events');
export const rsvpEliteEvent = (eventId: string): Promise<AxiosResponse> => api.post(`/elite/events/${eventId}/rsvp`);
export const getEliteAnalytics = (): Promise<AxiosResponse> => api.get('/elite/analytics');
export const getEliteConcierge = (matchId: string, preferences?: string): Promise<AxiosResponse> => api.post(`/elite/ai-concierge?match_id=${matchId}${preferences ? `&preferences=${encodeURIComponent(preferences)}` : ''}`);
